import { render, staticRenderFns } from "./WorldSection.vue?vue&type=template&id=18920ee8&"
import script from "./WorldSection.vue?vue&type=script&lang=js&"
export * from "./WorldSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports